import { useContext } from 'react';
import FeaturesContext from 'src/context/FeaturesContext';
import { FEATURES, isFeatureEnabled } from 'src/utils/features';
import { hasDifferentMaterialTypeSets } from 'src/utils/validation';

export default function useMaterialTypeBlendingBlock(sourceBatch, destinationBatch) {
  const { features } = useContext(FeaturesContext);

  return (
    isFeatureEnabled(features, FEATURES.BLOCK_MATERIAL_TYPE_BLENDING) &&
    hasDifferentMaterialTypeSets(sourceBatch, destinationBatch)
  );
}
